import { useTranslation } from "react-i18next";

/**
 * Custom hook to change the client-side locale.
 *
 * This hook provides a function to asynchronously change the i18next language
 * and update the HTML document's language attribute. It ensures that the language
 * is only changed if the new locale is different from the current language.
 *
 * @returns {Function} mutateAsync - Asynchronously changes the application's locale.
 */
export function useClientSideLocaleChange() {
    const { i18n } = useTranslation();

    const mutateAsync = async (locale: string) => {
        
        // Change i18next language, if the new locale is different
        if (locale !== i18n.language) {
            await i18n.changeLanguage(locale);
            document.documentElement.lang = locale;
        }
    };

    return {
        mutateAsync,
    };
}
